import { useSelector } from "react-redux";

function IntroArea() {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const currentPreviewState = useSelector((state) => state.cardPreview);

  const currentProduct = currentRequest.Products[currentRequest.CurrentProduct];

  return (
    <div className="intro-area">
      <img alt={currentPreviewState.Occasion.Description} src={ ( (currentPreviewState.ConfiguratorImage) ? currentPreviewState.ConfiguratorImage : currentProduct.DefaultRightPanelImage) } />
      {currentPreviewState.ConfiguratorSummary && (
        <div className="intro-area-summary"><div dangerouslySetInnerHTML={{__html: currentPreviewState.ConfiguratorSummary}} /></div>
      )}
    </div>
  );
}

export default IntroArea;
